import React from 'react';
import { SalvTooltipWrapperProps } from '@salvapp/ui-components/build/SalvTooltipWrapper/SalvTooltipWrapper.types';
import { CommonTooltip, TooltipType } from './CommonTooltip';

export const WarnTooltip = ({ tooltip }: Pick<SalvTooltipWrapperProps, 'tooltip'>) => {
  return <CommonTooltip tooltip={tooltip} type={TooltipType.WARN} />;
};
